exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table tr:first-child>td[data-v-637d9f52]{border-top:none}", ""]);

// exports
